import { render, staticRenderFns } from "./LeftFourth.vue?vue&type=template&id=82d395d4"
import script from "./LeftFourth.vue?vue&type=script&lang=js"
export * from "./LeftFourth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports